export default {
    header: {
        logout: 'Đăng xuất',
        profile: 'Thông tin cá nhân',
        hotline: 'Hotline',
        language: 'Ngôn ngữ'
    },
    footer: {},
    menu: {
        // Tái cấu trúc menu 2026-07: section (tiêu đề phân vùng) + nhóm gộp
        sectionCommunication: 'Truyền thông',
        sectionEducation: 'Học sinh & Giảng dạy',
        sectionServices: 'Dịch vụ',
        sectionFinance: 'Tài chính',
        sectionOperations: 'Vận hành',
        sectionSystem: 'Hệ thống',
        groupMyWork: 'Công việc của tôi',
        groupUserPermission: 'Người dùng & Phân quyền',
        groupSchoolData: 'Trường & Dữ liệu',
        groupNotificationNews: 'Thông báo & Tin tức',
        groupStudentParent: 'Học sinh & Phụ huynh',
        groupTeaching: 'Giảng dạy & TKB',
        groupClb: 'Câu lạc bộ',
        groupOtherServices: 'Dịch vụ khác',
        groupMeal: 'Suất ăn',
        groupTuition: 'Học phí & Thu chi',
        groupHrTimekeeping: 'Nhân sự & Chấm công',
        groupStaff: 'Nhân sự',
        groupTimekeeping: 'Chấm công',
        groupInventoryPurchase: 'Kho & Mua sắm',
        notification: 'Thông báo',
        news: 'Tin tức',
        email: 'Email',
        admissions: 'Tuyển sinh',
        bus: 'Xe bus',
        latePickup: 'Đón muộn',
        nutrition: 'Dinh dưỡng',
        medical: 'Y tế',
        payment: 'Thanh toán',
        assets: 'Tài sản',
        guest: 'Khách',
        profile: 'Thông tin cá nhân',
        listBrandname: 'Danh sách Brandname',
        listPhoneNumber: 'Danh sách số điện thoại',
        listRequest: 'Danh sách yêu cầu',
        createRequest: 'Gửi yêu cầu',
        logout: 'Đăng xuất',
        // Dashboard
        dashboard: 'Dashboard',
        // Account Management
        accountManagement: 'Quản lý tài khoản',
        // Notification
        notificationManagement: 'Quản lý thông báo',
        // News
        newsManagement: 'Quản lý tin tức',
        // Attendance
        attendance: 'Điểm danh',
        dailyAttendance: 'Điểm danh hàng ngày',
        leaveRequest: 'Xin nghỉ phép hộ h/s',
        mealAttendance: 'Điểm danh ăn',
        latePickupAttendance: 'Điểm danh đón muộn',
        clbAttendance: 'Điểm danh CLB',
        attendanceReport: 'Báo cáo điểm danh',
        clbAttendanceReport: 'Báo cáo điểm danh CLB',
        mealReport: 'Báo cáo ăn',
        // Meal Management
        mealManagement: 'Quản lý ăn/Nghỉ',
        mealService: 'Quản lý dịch vụ ăn',
        mealRegister: 'Đăng ký ăn',
        // Parent Management
        parentManagement: 'Quản lý phụ huynh',
        parentList: 'Danh sách phụ huynh',
        parentLink: 'Liên kết phụ huynh',
        // SMS/Gmail
        smsManagement: 'Tin nhắn SMS/Gmail',
        sendExternalSms: 'Quản lý gửi tin nhắn ngoài',
        sendAdvertisingEmail: 'Quản lý gửi Email quảng cáo',
        // Admissions
        admissionsManagement: 'Quản lý tuyển sinh',
        statusNameManagement: 'Quản lý tên trạng thái',
        customerGroupManagement: 'Quản lý nhóm khách hàng',
        enrollmentCampaign: 'Chiến dịch tuyển sinh',
        customerList: 'Danh sách khách hàng',
        careToday: 'Chăm sóc hôm nay',
        kindergartenPartner: 'Đối tác mầm non',
        testSession: 'Đợt test đầu vào',
        admissionBudget: 'Ngân sách tuyển sinh',
        admissionsReport: 'Báo cáo',
        // Timekeeping Config
        timekeepingConfig: 'Cấu hình chấm công',
        config: 'Cấu hình',
        workShift: 'Ca làm việc',
        teachingAssignment: 'Phân công giảng dạy',
        supplementaryWork: 'Quản lý việc bổ sung',
        eventAssignment: 'Phân công sự kiện',
        attendanceZone: 'Quản lý vùng chấm công',
        attendanceWifi: 'Quản lý wifi chấm công',
        timekeepingDevice: 'Quản lý máy chấm công',
        // Timekeeping
        timekeeping: 'Chấm công',
        leaveApplication: 'Đơn xin nghỉ',
        swapLesson: 'Đơn đổi tiết',
        timekeepingList: 'Chấm công',
        complaintApproval: 'Duyệt khiếu nại',
        staffTimekeepingView: 'NV xem chấm công',
        staffLessonView: 'NV xem chấm tiết',
        timekeepingReport: 'Báo cáo chấm công',
        lessonReport: 'Báo cáo chấm tiết',
        lessonComplaint: 'Quản lý khiếu nại chấm tiết',
        // System
        system: 'Hệ thống',
        schoolGroupManagement: 'Quản lý nhóm trường',
        schoolManagement: 'Quản lý trường học',
        dataDeclaration: 'Khai báo dữ liệu',
        schedule: 'Thời khóa biểu',
        dataTransfer: 'Kết chuyển dữ liệu',
        permissionManagement: 'Quản lý quyền',
        permissionGroupManagement: 'Quản lý nhóm quyền',
        userGroupPermission: 'Phân quyền nhóm người dùng',
        userManagement: 'Quản lý người dùng',
        versionManagement: 'Quản lý phiên bản',
        // Student
        studentManagement: 'Quản lý học sinh',
        admissionsDiscount: 'Ưu đãi tuyển sinh',
        studentProfile: 'Hồ sơ học sinh',
        firstYearClassAssignment: 'Phân lớp học sinh đầu cấp',
        gradeManagement: 'Quản lý điểm',
        finalGradeReport: 'Báo cáo điểm tổng kết',
        // Staff
        staffManagement: 'Quản lý cán bộ',
        staffList: 'Quản lý cán bộ',
        officerDocumentType: 'Danh mục hồ sơ cán bộ',
        officerReport: 'Báo cáo nhân sự',
        // Fee
        feeManagement: 'Quản lý chi phí',
        feeItems: 'Các khoản phí',
        feeFormula: 'Công thức tính phí',
        feeDryRun: 'Tính thử học phí',
        feeEmail: 'Gửi email học phí',
        feeItemCollection: 'Quản lý thu các khoản phí',
        tuitionConfig: 'Cấu hình giá học phí',
        tuitionReport: 'Báo cáo thu học phí',
        feeCollectionReport: 'Báo cáo thu các khoản phí',
        receiptManagement: 'Quản lý thu chi',
        // Bus
        busManagement: 'Quản lý xe bus',
        busServiceType: 'Loại dịch vụ xe bus',
        busRoute: 'Tuyến xe bus',
        busRegister: 'Đăng ký xe bus',
        busRegisterRequest: 'Yêu cầu đăng ký xe bus',
        busAttendanceReport: 'Báo cáo điểm danh xe bus',
        // CLB
        clbManagement: 'Quản lý CLB',
        clbClass: 'Quản lý lớp CLB',
        clbRegister: 'Quản lý đăng ký CLB',
        // Summer
        summerManagement: 'Quản lý học hè',
        summerClass: 'Quản lý lớp học hè',
        summerRegister: 'Quản lý đăng ký học hè',
        // Other Services
        otherServiceManagement: 'Quản lý dịch vụ khác',
        productManagement: 'Quản lý sản phẩm',
        serviceManagement: 'Quản lý dịch vụ',
        serviceRegister: 'Quản lý đăng ký dịch vụ',
        serviceApproval: 'Duyệt yêu cầu đăng ký/hủy dịch vụ',
        // Late Pickup
        latePickupManagement: 'Quản lý đón muộn',
        latePickupConfig: 'Cấu hình giá đón muộn',
        latePickupRegister: 'Đăng ký đón muộn',
        latePickupReport: 'Báo cáo đón muộn',
        // Nutrition
        nutritionManagement: 'Quản lý dinh dưỡng',
        foodType: 'Loại thực phẩm',
        foodGroup: 'Nhóm thực phẩm',
        supplier: 'Nhà cung cấp',
        food: 'Thực phẩm',
        dish: 'Món ăn',
        menuManagement: 'Thực đơn',
        weeklyMenu: 'Thực đơn tuần',
        dailyMenu: 'Thực đơn hàng ngày',
        // Medical
        medicalManagement: 'Quản lý y tế',
        medicationManagement: 'Quản lý dặn thuốc',
        // Log
        logManagement: 'Quản lý LOG'
    },
    common: {
        search: 'Tìm kiếm',
        add: 'Thêm mới',
        edit: 'Sửa',
        delete: 'Xóa',
        save: 'Lưu',
        cancel: 'Hủy',
        confirm: 'Xác nhận',
        close: 'Đóng',
        back: 'Quay lại',
        next: 'Tiếp theo',
        previous: 'Trước đó',
        submit: 'Gửi',
        reset: 'Đặt lại',
        export: 'Xuất file',
        import: 'Nhập file',
        print: 'In',
        view: 'Xem',
        detail: 'Chi tiết',
        status: 'Trạng thái',
        action: 'Hành động',
        all: 'Tất cả',
        active: 'Hoạt động',
        inactive: 'Không hoạt động',
        yes: 'Có',
        no: 'Không',
        loading: 'Đang tải...',
        noData: 'Không có dữ liệu',
        success: 'Thành công',
        error: 'Lỗi',
        warning: 'Cảnh báo',
        info: 'Thông tin',
        total: 'Tổng',
        page: 'Trang',
        rowsPerPage: 'Số dòng mỗi trang',
        of: 'của',
        home: 'Trang chủ',
        selectAll: 'Chọn tất cả',
        deselectAll: 'Bỏ chọn tất cả',
        required: 'Bắt buộc',
        optional: 'Tùy chọn',
        from: 'Từ',
        to: 'Đến',
        date: 'Ngày',
        time: 'Thời gian',
        startDate: 'Ngày bắt đầu',
        endDate: 'Ngày kết thúc',
        createdAt: 'Ngày tạo',
        updatedAt: 'Ngày cập nhật',
        createdBy: 'Người tạo',
        updatedBy: 'Người cập nhật',
        name: 'Tên',
        code: 'Mã',
        description: 'Mô tả',
        note: 'Ghi chú',
        phone: 'Số điện thoại',
        email: 'Email',
        address: 'Địa chỉ',
        gender: 'Giới tính',
        male: 'Nam',
        female: 'Nữ',
        birthday: 'Ngày sinh',
        year: 'Năm',
        month: 'Tháng',
        week: 'Tuần',
        day: 'Ngày',
        schoolYear: 'Năm học',
        semester: 'Học kỳ',
        class: 'Lớp',
        grade: 'Khối',
        student: 'Học sinh',
        teacher: 'Giáo viên',
        parent: 'Phụ huynh',
        staff: 'Cán bộ',
        school: 'Trường',
        department: 'Phòng ban',
        position: 'Chức vụ',
        subject: 'Môn học',
        confirmDelete: 'Bạn có chắc chắn muốn xóa?',
        confirmAction: 'Bạn có chắc chắn muốn thực hiện hành động này?',
        deleteSuccess: 'Xóa thành công',
        saveSuccess: 'Lưu thành công',
        updateSuccess: 'Cập nhật thành công',
        createSuccess: 'Tạo mới thành công',
        operationFailed: 'Thao tác thất bại',
        networkError: 'Lỗi kết nối mạng',
        sessionExpired: 'Phiên đăng nhập hết hạn',
        permissionDenied: 'Không có quyền truy cập',
        invalidData: 'Dữ liệu không hợp lệ',
        fileNotFound: 'File không tồn tại',
        uploadSuccess: 'Tải lên thành công',
        downloadSuccess: 'Tải xuống thành công',
        pleaseSelect: 'Vui lòng chọn',
        pleaseEnter: 'Vui lòng nhập',
        invalidFormat: 'Định dạng không hợp lệ',
        maxLength: 'Độ dài tối đa',
        minLength: 'Độ dài tối thiểu'
    },
    auth: {
        login: 'Đăng nhập',
        logout: 'Đăng xuất',
        username: 'Tên đăng nhập',
        password: 'Mật khẩu',
        rememberMe: 'Ghi nhớ đăng nhập',
        forgotPassword: 'Quên mật khẩu?',
        loginFailed: 'Sai tên đăng nhập hoặc mật khẩu!',
        loginSuccess: 'Đăng nhập thành công',
        logoutSuccess: 'Đăng xuất thành công',
        changePassword: 'Đổi mật khẩu',
        currentPassword: 'Mật khẩu hiện tại',
        newPassword: 'Mật khẩu mới',
        confirmPassword: 'Xác nhận mật khẩu'
    }
}
